import { useEffect } from 'react';

/**
 * The platform control-plane app. PLATFORM_ADMINs do all their cross-tenant
 * work there now — the in-ERP platform-admin console was retired — so when one
 * signs into (or is SSO'd into) the ERP we bounce them straight out.
 */
const PLATFORM_APP_URL = 'https://platform.zafroi.com';

/**
 * Landing target of `homeForUser(PLATFORM_ADMIN)`. React Router's `navigate()`
 * only handles in-app paths, so the auth flows route here — an in-app sentinel
 * — and this component performs the real cross-origin bounce. The shared
 * `.zafroi.com` refresh cookie lets the platform app boot already authenticated.
 */
export function ExitToPlatform() {
  useEffect(() => {
    window.location.replace(PLATFORM_APP_URL);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        color: '#475569',
        fontSize: '0.95rem',
      }}
    >
      Redirecting to the Zafroi platform console…
    </div>
  );
}
